module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "konfigurator-order"
    }
  }, [_c('right-content-header'), _vm._v(" "), _c('h2', [_vm._v(_vm._s(_vm._f("translate")('Order')))]), _vm._v(" "), _c('div', {
    staticClass: "form-type-select"
  }, [_c('div', {
    staticClass: "select-content"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.$store.state.mazlicek.krmivo.tydny.value),
      expression: "$store.state.mazlicek.krmivo.tydny.value"
    }],
    staticClass: "form-select",
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.$store.state.mazlicek.krmivo.tydny, "value", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }, _vm.weekChanged]
    }
  }, _vm._l((_vm.weeks), function(tyden, index) {
    return _c('option', {
      key: index,
      domProps: {
        "value": tyden.pocetTydnu
      }
    }, [_vm._v(_vm._s(tyden.nazev) + "\n                    ")])
  }))])]), _vm._v(" "), _c('div', {
    staticClass: "views-field views-field-field-model-cena-davky"
  }, [(_vm.$store.state.mazlicek.krmivo.tydny.value !== 0) ? _c('div', {
    staticClass: "vaha-krmiva-celkem"
  }, [_c('div', {
    staticClass: "cena-label"
  }, [_vm._v("\n            " + _vm._s(_vm._f("translate")('Weight of the food')) + "\n\t\t")]), _vm._v(" "), _c('div', {
    staticClass: "cena-value"
  }, [_c('span', [_vm._v(_vm._s(_vm.round(_vm.totalWeight / 100) / 10) + " kg / " + _vm._s(_vm.round((_vm.totalWeight * 0.00220462262) * 10 | _vm.round) / 10) + " lb")])])]) : _c('div', {
    staticClass: "vaha-krmiva-celkem"
  }, [_c('div', {
    staticClass: "cena-label"
  }, [_vm._v("\n            " + _vm._s(_vm._f("translate")('Weight of the food')) + "\n\t\t")]), _vm._v(" "), _c('div', {
    staticClass: "cena-value"
  }, [_c('span', [_vm._v(_vm._s(_vm.naZkouskuVaha) + " g")])])]), _vm._v(" "), (_vm.showTotalPrice) ? _c('div', {
    staticClass: "cena-davky"
  }, [_c('div', {
    staticClass: "cena-label"
  }, [_vm._v("\n                    " + _vm._s(_vm._f("translate")('Price / day')) + "\n                ")]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.priceIsBeingCalculated),
      expression: "!priceIsBeingCalculated"
    }],
    staticClass: "cena-value"
  }, [_c('span', [_vm._v("€" + _vm._s((_vm.pricePerDay + '').replace('.', ',')))])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.priceIsBeingCalculated),
      expression: "priceIsBeingCalculated"
    }],
    staticClass: "cena-value"
  }, [_c('span', [_vm._v(_vm._s(_vm._f("translate")('recalculating')))])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "cena-complete"
  }, [_c('div', {
    staticClass: "cena-label"
  }, [_vm._v("\n            " + _vm._s(_vm._f("translate")('Total price')) + "\n\t\t")]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.priceIsBeingCalculated),
      expression: "!priceIsBeingCalculated"
    }],
    staticClass: "cena-value"
  }, [_c('span', [_vm._v("€" + _vm._s(_vm.totalPrice))])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.priceIsBeingCalculated),
      expression: "priceIsBeingCalculated"
    }],
    staticClass: "cena-value"
  }, [_c('span', [_vm._v(_vm._s(_vm._f("translate")('recalculating')))])])])]), _vm._v(" "), (_vm.additional_info_order) ? _c('div', {
    staticClass: "objednavka-btn-text"
  }, [_c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.additional_info_order.content)
    }
  })]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "objednavka-btn"
  }, [_c('button', {
    staticClass: "button",
    on: {
      "click": _vm.objednatKrmivo
    }
  }, [_vm._v(_vm._s(_vm._f("translate")('Order Haffit')))])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-18fd941c","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Order.vue
// module id = 541
// module chunks = 1